const APPROVE = "approve";
const DISCARD = "discard";
const FORBIDDEN_TO_DELETE_BATCH = "Forbidden to Delete Batch";
const FORBIDDEN_TO_UPDATE_BATCH = "Forbidden to Update Batch";

export {
    APPROVE,
    DISCARD,
    FORBIDDEN_TO_DELETE_BATCH,
    FORBIDDEN_TO_UPDATE_BATCH
};
